import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useMenuItemStyles = (theme: Theme) => {
  const isDarkTheme = theme.palette.mode === 'dark';
  const textColor = isDarkTheme ? theme.palette.primary.light : '#0f172a';

  return {
    root: css({
      '&.MuiMenuItem-root': {
        color: textColor,
        display: 'flex',
        borderRadius: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2.5),
        '&:hover': {
          backgroundColor: 'rgba(14,165,233,0.1)',
          '& .MuiLink-root': {
            textDecoration: 'none',
          },
          '& h6.MuiTypography-subtitle1': {
            color: textColor,
          },
        },
        '&:visited .MuiLink-root': {
          color: textColor,
        },
        '& .MuiListItemIcon-root': {
          flexGrow: 0,
          flexShrink: 0,
        },
        '& .MuiListItemText-root': {
          flexGrow: 1,
          flexShrink: 1,
        },
      },
    }),
    headerMenuItemText: css({
      '& h6.MuiTypography-subtitle1': {
        fontSize: 15,
        fontWeight: 600,
        letterSpacing: 0.3,
        color: textColor,
      },
    }),
    indentedMenuItemText: css({
      paddingLeft: theme.spacing(1.5),
    }),
    icon: css({
      color: textColor,
    }),
    routerLink: css({
      textDecoration: 'none',
    }),
    subMenu: css({
      '&.MuiList-root': {
        paddingLeft: theme.spacing(1),
        backgroundColor: isDarkTheme ? theme.palette.background.paper : '#ffffff',
        borderRadius: theme.spacing(2),
        marginTop: theme.spacing(1),
        boxShadow: '0 25px 60px -35px rgba(15,23,42,0.18)',
        border: `1px solid ${isDarkTheme ? theme.palette.grey[200] : 'rgba(226,232,240,0.7)'}`,
      },
    }),
    subMenuChevron: css({
      position: 'absolute',
      right: theme.spacing(1.5),
      top: '50%',
      transform: 'translateY(-50%)',
      color: isDarkTheme ? theme.palette.text.secondary : 'rgba(15,23,42,0.45)',
    }),
  };
};
